<app-share-button ></app-share-button>
<div class="row">
    <div class="col-md-8 ScrollStyle-1">
        
        <div class="card crd p-3">
            <div class="row">
                <div class="col-md-10 col10 mt-2">
                    <h2>
                        <h2> बुकिंग प्रोफ़ाइल कैसे बनाएं? </h2>
                    </h2>
                </div>

                <div class="col-md-2 col2"><a href="javascript:void(0)" (click)="openShareOptions()"> <button class="btn share"><img src="./assets/share (5).svg" style="width: 30px;" (click)="menues('share-button')"
                    alt=""> </button> </a></div>
                <!-- <div class="col-md-12" (mouseover)="showpayment(true,'1')"
                    (mouseout)="showpayment(false,'1')" id='59'>
                    <div
                        style="max-width: 100%; overflow: hidden; padding-bottom: 56.25%; position: relative;">

                        <iframe
                            class="i-frame"
                            src="https://www.youtube.com/embed/RLUj" title="YouTube video player"
                            frameborder="0"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                            allowfullscreen></iframe>
                    </div>
                </div> -->
                <div class="col-md-12 mt-3" (mouseover)="showpayment(true,'2')"
                    (mouseout)="showpayment(false,'2')" id='60'>
                  
                    <h4>
                        बुकिंग प्रोफ़ाइल कैसे बनाएं?

                    </h4>
                    <label for="" class="mt-3">अपने PayG खाते में लॉगिन करें. </label>
                    <div class="row">
                        <div class="col-md-12 text-center">
                            <img src="./assets/booking1.png" width="100%" height="100%" alt="">
                        </div>
                    </div>
                   
                    <label for="" class="mt-4">डैशबोर्ड के बाईं ओर, “Booking
                        and Ticketing” सुविधा पर क्लिक करें। </label>

                    <div class="row">
                        <div class="col-md-12 text-center">
                            <img src="./assets/booking2.png" width="100%" height="100%" alt="">
                        </div>
                    </div>

                   
                    <label for="" class="mt-3">डैशबोर्ड के ऊपरी दाएं कोने पर, “Create
                        new booking event” पर क्लिक करें और “Create booking
                        profile for venue event” या “Create booking profile for online
                        event” विकल्पों में से एक का चयन करें। </label>

                    <div class="row">
                        <div class="col-md-12 text-center">
                            <img src="./assets/booking3.png" width="100%" height="100%" alt="">
                        </div>
                        <div class="col-md-12 text-center">
                            <img src="./assets/booking4.png" width="100%" height="100%" alt="">
                        </div>
                    </div>
                   
                    <label for="" class="mt-3">इसके बाद, एक टेम्प्लेट चुनें या अपना
                        खुद का बनाएं और प्रोफ़ाइल नाम, श्रेणी, द्वारा आयोजित, ईवेंट के बारे में आदि
                        सहित सभी जानकारी भरें। आप जितनी चाहें उतनी फ़ील्ड जोड़ और हटा सकते हैं
                        क्योंकि यह पूरी तरह से अनुकूलन योग्य है। </label>
                    <div class="row mt-3">
                        <div class="col-md-12 text-center">
                            <img src="./assets/booking5.png" width="100%" height="100%" alt="">
                        </div>
                        <div class="col-md-12 mt-2 text-center">
                            <img src="./assets/booking6.png" width="100%" height="100%" alt="">
                        </div>
                    </div>

                    
                    <label for="" class="mt-3">अगले चरण पर आगे बढ़ते हुए, स्थान और समय
                        के विवरण भरें। </label>
                    <div class="row mt-3">
                        <div class="col-md-12 text-center">
                            <img src="./assets/booking7.png" width="100%" height="100%" alt="">
                        </div>
                        <div class="col-md-12 mt-2 text-center">
                            <img src="./assets/booking8.png" width="100%" height="100%" alt="">
                        </div>
                        <div class="col-md-12 mt-2 text-center">
                            <img src="./assets/booking9.png" width="100%" height="100%" alt="">
                        </div>
                    </div>
                   
                    <label for="" class="mt-3">इसके बाद, ग्राहक प्रकार जैसे
                        राष्ट्रीयता, लिंग आदि सेट करें। फिर टिकट सेवाएं बनाएं चुनें, जहां आप चुन
                        सकते हैं कि अपने ग्राहकों के लिए एक टिकट या कई टिकट जेनरेट करना है या नहीं।
                        फिर अन्य सभी विवरण दर्ज करें। यदि आप "केवल बुकिंग की आवश्यकता है" विकल्प
                        चुनते हैं, तो कोई राजस्व नहीं कमाया जाएगा; यह केवल आयोजन के लिए प्रवेश टिकट
                        के रूप में काम करेगा। यदि व्यापारी अपने ग्राहकों को अन्य सेवाएँ प्रदान करना
                        चाहता है तो "ऐड-ऑन बनाएँ" पर क्लिक करें। </label>

                    <div class="row mt-3">
                        <div class="col-md-12 text-center">
                            <img src="./assets/booking10.png" width="100%" height="100%" alt="">
                        </div>
                        <div class="col-md-12 mt-2 text-center">
                            <img src="./assets/booking11.png" width="100%" height="100%" alt="">
                        </div>
                        <div class="col-md-12 mt-2 text-center">
                            <img src="./assets/booking12.png" width="100%" height="100%" alt="">
                        </div>
                    </div>

                    <label for="" class="mt-3">"View Profile" अगला चरण है, जहां आप
                        अपने ग्राहकों द्वारा वास्तव में देखे जाने से पहले अपनी प्रोफ़ाइल का
                        पूर्वावलोकन कर सकते हैं। </label>
                    <div class="row mt-3">
                        <div class="col-md-12 text-center">
                            <img src="./assets/booking13.png" width="100%" height="100%" alt="">
                        </div>
                    </div>
                    
                    <label for="" class="mt-3">अंतिम चरण “Create ticket” है। उत्पन्न
                        लिंक को कॉपी करें या क्यूआर कोड डाउनलोड करें और इसे अपने ग्राहकों के साथ
                        साझा करें। </label>
                    <div class="row mt-3">
                        <div class="col-md-12 text-center">
                            <img src="./assets/booking14.png" width="100%" height="100%" alt="">
                        </div>
                    </div>
                    <label for="" class="mt-3">अंत में, PayG के भीतर बुकिंग और टिकटिंग
                        प्रोफ़ाइल स्थापित करना एक सीधी प्रक्रिया है जो आपको आरक्षण और लेनदेन को
                        निर्बाध रूप से प्रबंधित करने का अधिकार देती है। ऊपर बताए गए चरणों का पालन
                        करके, आप एक मजबूत प्रोफ़ाइल बनाने की राह पर होंगे जो आपके व्यवसाय की विशिष्ट
                        आवश्यकताओं को पूरा करती है। याद रखें कि एक अच्छी तरह से कॉन्फ़िगर की गई
                        बुकिंग और टिकटिंग प्रोफ़ाइल न केवल आपके संचालन को सुव्यवस्थित करती है बल्कि
                        ग्राहकों की संतुष्टि को भी बढ़ाती है, जिससे विश्वास और वफादारी बढ़ती है। यदि
                        आपको सेटअप प्रक्रिया के दौरान किसी भी चुनौती का सामना करना पड़ता है, तो
                        हमारी समर्पित सहायता टीम आपकी सहायता के लिए तुरंत उपलब्ध है। अपनी बुकिंग और
                        टिकटिंग आवश्यकताओं के लिए PayG को चुनने के लिए धन्यवाद - हम आपके व्यवसाय की
                        सफलता में योगदान देने के लिए तत्पर हैं। </label>

                </div>
            </div>
        </div>
</div>
        <div class="col-md-4  hide-tbl content2 ">
            <div class="card crd p-4">
                <div class="row">
                    <div class="col-md-12">
                        
                        <h5>
                            विषयसूची :
                        </h5>
                    </div>
                    <div class="col-md-12 mt-2">
                        <!-- <a href="#59">
                        <div class="row">
                            <div class="col-md-2"> <img src="./assets/video.svg" class="tab-icon intro"
                                    alt=""> &nbsp;</div>
                            <div class="col-md-10">
                                <span style="cursor: pointer;" class="videoHover"
                                    [ngClass]="{'video':colors=='1'}" (click)="color('1')">
                                   
Creating Booking and Ticketing Profile
</span>
                            </div>
                        </div>
                    </a> -->
                    </div>

                    <div class="col-md-12 mt-3">
                        <a href="#60">
                            <div class="row">
                                <div class="col-md-2"> <img   src="./assets/edit.svg" class="tab-icon intro"
                                        alt="">
                                </div>
                                <div class="col-md-10">
                                   
                                    <span style="cursor: pointer;" class="textHover"
                                        [ngClass]="{'text':colors=='2'}" (click)="color('2')"
                                       >

                                        बुकिंग और टिकटिंग प्रोफ़ाइल बनाना
                                    </span>
                                </div>
                            </div>
                        </a>
                    </div>

                </div>
            </div>
        </div>
        <div class="col-md-9 hide ft-9">
            <hr>
            <div class=" row crd">
                <div class="col-md-8">
                    
                    <a [routerLink]="['/booking-tecketing']"><button class="btn btn-color" (click)="menues('Booking & Ticketing')" >
                        <img src="./assets/Arrow 3.svg" alt="">&nbsp;&nbsp;बुकिंग और टिकटिंग
                    </button></a> 
                </div>
                <div class="col-md-4    ">
                    <a [routerLink]="['/pay-out']">   <button class="btn  btn-color"  >पे आउट
                        &nbsp;<img src="./assets/Arrow 2 1.svg" alt=""></button></a>
                </div>
             
            </div>
        </div>
        </div>